import { render, staticRenderFns } from "./checkout.module.vue?vue&type=template&id=84ea2294"
import script from "./checkout.module.vue?vue&type=script&lang=js"
export * from "./checkout.module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports